import React, { useEffect, useState } from 'react'
import { useAxios } from '../../../hooks/useAxios';
import { useTranslation } from "react-i18next";


export const useTodosLibros = ( {counter = 0, books} ) => {
    const [t, i18n] = useTranslation("biblioteca");

    const [libros, setLibros] = useState( books );
    const [url = `/library/nbooks2?offset=0&next=200&sitioid=2&lenguaje=${i18n.language}`, setUrl] = useState(null)
    
    const { data, isLoading, error } = useAxios(url);

    useEffect(() => {
        if(data){
            setLibros( data );
        }else {
        }
    }, [data]);
    
    useEffect(() => {
        if(counter > 0) {
            setUrl(`/library/nbooks2?offset=0&next=200&sitioid=2&lenguaje=${i18n.language}`);
        }else {
            setLibros( books );
            setUrl(`/library/nbooks2?offset=0&next=200&sitioid=2&lenguaje=${i18n.language}`);
        }
    },[counter, i18n.language]);



    return {
        libros,
        isLoading,
        error,
    };
}

export const useTodosLibros_Mov = ( {counter = 0, books} ) => {
    const [t, i18n] = useTranslation("biblioteca");
    
    const [libros_mov, setLibros] = useState( books );
    const [url = `/library/nbooks2?offset=0&next=200&sitioid=2&lenguaje=${i18n.language}`, setUrl] = useState(null)
    
    const { data, isLoading_mov, error_mov } = useAxios(url);

    useEffect(() => {
        if(data){
            setLibros( data );
        }else {
        }
    }, [data]);
    
    useEffect(() => {
        if(counter > 0) {
            setUrl(`/library/nbooks2?offset=0&next=200&sitioid=2&lenguaje=${i18n.language}`);
        }else {
            setLibros( books );
            setUrl(`/library/nbooks2?offset=0&next=200&sitioid=2&lenguaje=${i18n.language}`);
        }
    },[counter, i18n.language]);



    return {
        libros_mov,
        isLoading_mov,
        error_mov,
    };
}
